import React, { useState, useEffect } from "react";
import "../../css_files/Master/SearchGSTMaster.css";
import CloseForm from "./CloseForm";
import axiosInstance from "../../api";
import Select from "react-select";

function SearchGSTMaster({
  setshowsearchform,
  setIds,
  setgstId,
  setpagenumber,
  setReload,
  setSearch,
  reload,
}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/GST/GetGSTDropdown`)
      .then((res) => {
        setOptions(res.data);
      })
      .catch(console.log);
  }, []);
  return (
    <div className="search-gst-master-form">
      <h3>Search GST Master</h3>
      <blockquote>
        <label>Id</label>
        <input
          type="number"
          placeholder="Enter GST Master Id (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setgstId(e.target.value);
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setgstId(e.target.value);
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>
      <blockquote>
        <label>GST Rate</label>
        <Select
          isSearchable
          options={options}
          onChange={(values) => {
            if (values) setIds(values.map((x) => x.value));
          }}
          isMulti
          isClearable
          placeholder="Enter GST Rate"
          hideSelectedOptions={false}
          closeMenuOnSelect={false}
          menuPlacement="top"
          styles={{
            container: (base) => ({
              ...base,
              width: "100%",
            }),
            placeholder: (base) => ({
              ...base,
              color: "black",
            }),
            control: (base, state) => ({
              ...base,
              borderColor: "black",
              "&:hover": {
                borderColor: "black",
              },
              boxShadow: "none",
            }),
            singleValue: (base) => ({
              ...base,
              color: "black",
            }),
            dropdownIndicator: (base) => ({
              ...base,
              color: "black",
              "&:hover": {
                color: "black",
              },
            }),
            indicatorSeparator: (base) => ({
              ...base,
              backgroundColor: "black",
            }),
            noOptionsMessage: (base) => ({
              ...base,
              color: "black",
            }),
          }}
        />
      </blockquote>

      <blockquote>
        <label>Search</label>
        <input
          type="search"
          placeholder="Enter Search Keyword (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>

      <CloseForm
        close={(x) => {
          setshowsearchform(x);
          setIds([]);
          setgstId(null);
          setSearch("");
          setReload(!reload);
        }}
      />
    </div>
  );
}

export default SearchGSTMaster;
